module.exports = __webpack_public_path__ + "images/datacamp-alternative-365-certificate.png";